<template>
<div class="container-fluid p-0">
    <nav class="navbar navbar-expand-md bg-primary">
        <ul class="navbar-nav ml-auto">

        <li class="nav-item dropdown mr-3 mt-1" :style="{ right: isSidebar ? '-217px' : '0px' }">
          <!-- <a id="logout-link" href="#" @click.prevent="logout">Logout</a> -->
          <!-- vs-custom-content vs-trigger-click -->
          <div class="menu-item" @click="isOpen = !isOpen">
            <a class="a-icon" href.prevent>
              <h6 class="text-white mt-2 text-capitalize">
                {{ currentUser }}
                <vs-icon class icon="expand_more"></vs-icon>
              </h6>
            </a>
            <transition name="fade" appear>
              <div class="sub-menu" v-if="isOpen">
                <a
                  class="dropdown-item"
                  @click="ChangePassword()"
                  role="menuitem"
                  >Change Password</a
                >
                <a
                  class="dropdown-item"
                  href="./Unodc_Manual_Review-converted.pdf"
                  target="_blank"
                  role="menuitem"
                  >Help</a
                >
                <a class="dropdown-item" @click="logout()" role="menuitem"
                  >Logout</a
                >
              </div>
            </transition>
          </div>
        </li>
      </ul>
    </nav>

</div>
</template>

<script>
import axios from "axios";

// import Version from "../../commonPages/Version"

export default {
  props: {
    isSidebar: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    activeItem: 0,
    search: "",
    currentUser: "",
     isOpen: false
  }),
  created() {
    // bus.$on("sidebarStatus", data => {
    //   this.active = !data;
    // });
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    if (localStorage.getItem("currentUser")) {
      var getName = JSON.parse(localStorage.getItem("currentUser"));
      this.currentUser = getName.name;
    }
  },
  
    methods: {
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        logout() {
            let self = this;
            this.openLoading();
            axios
                .get(localStorage.getItem("BASE_PATH") + "/logout")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        clearLocalStorage();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        clearLocalStorage();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response) localStorage.removeItem("token");
                    localStorage.removeItem("currentUser");
                    sessionStorage.removeItem("project")
                    sessionStorage.removeItem("training")
                    self.$router.push({
                        path: "/"
                    });
                })
                .catch(error => {
                    if (error) localStorage.removeItem("token");
                    localStorage.removeItem("currentUser");
                    self.$router.push({
                        path: "/"
                    });
                });
        },
        ChangePassword() {
            const token = localStorage.getItem("token")
            this.$router.push(`/resetPassword/:${token}`);
        }
    },

}
</script>

<style>
.vs-input--placeholder {
    padding-top: 4px !important;
}

#menu-toggle {
    cursor: pointer !important;
}
</style><style scoped>
.vs-input--placeholder {
    top: 0px !important;
}

.icon-scale {
    vertical-align: bottom;
}

.examplex {
    display: flex;
    align-items: center;
    justify-content: center;
}

.examplex .a-icon {
    outline: none;
    text-decoration: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

.examplex .a-icon i {
    font-size: 18px;
}

.icon-scale {
    color: #fff !important;
}

.vs-dropdown-menu .con-input {
    margin-bottom: 20px;
}

.loginx h3 {
    color: rgba(0, 0, 0, 0.5);
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 5px;
}

.loginx p {
    max-width: 200px;
    font-size: 11px;
    padding: 5px;
}

.con-vs-dropdown--menu {
    width: 200px !important;
}

.bg-primary {
    /* height: 50px !important; */
    background: #06a6e0 !important;
}

nav .menu-item svg {
    width: 10px;
    margin-left: 10px;
}

nav .menu-item .sub-menu {
    position: absolute;
    background-color: #ffff;
    height: 100px;
    width: 142px !important;
    top: 39px;
    left: 45%;
    transform: translateX(-50%);
    width: max-content;
    border-radius: 0px 0px 16px 16px;
    border: 0.5px solid #C1BFBF;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
}

.fade-enter-active,
.fade-leave-active {
    transition: all .5s ease-out;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.version {
    position: absolute;
    bottom: 5px;
    z-index: 1;
    width: 86vw
}

@media (max-width: 768px) {
    .navbar-nav {
        flex-direction: initial !important;
    }
}

</style>
